/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TThemeStyleNames } from "@adapptio/lib-blueprint";
import { IResourceDependency, IResourceMetadata } from "../registries";

/**
 * Resource Types
 */
export enum RESOURCE_TYPES {
	DIRECTORY = "directory",
	VIEW = "view",
	ACTION = "action",
	CONFIG = "config",
	INTEGRATION = "integration",
	ROUTES = "routes",
	ENDPOINT = "endpoint",
	TRANSLATIONS = "translations",
	THEME = "theme",
	ASSET = "asset",
	MANIFEST = "manifest",
	README = "readme",
	UNKNOWN = "unknown"
}

/**
 * Resource Description
 */
export interface IResourceDescription {
	id: string;
	name: string;
	resourceType: RESOURCE_TYPES;
	basePath: string;
	parseData: {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		paramsSchema: any;
		valid: boolean;
		/** Integration type */
		integrationType?: string;
		/** Styles */
		styles?: TThemeStyleNames;
	};
	/** List of resources this one depends on */
	dependencies: string[];
	/** Last modified timestamp */
	lastModified: number;
	attributes?: {
		hidden?: boolean;
		allowWrite?: boolean;
		allowRemove?: boolean;
		allowRename?: boolean;
	};
	metadata?: IResourceMetadata;
}
